import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button"];

  async copyToClipboard() {
    const textToCopy = this.buttonTarget.getAttribute("data-clipboard-text");

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(textToCopy);
        this.showCopiedFeedback();
        return;
      } catch {
        // Fall through to legacy method
      }
    }

    this.copyWithLegacyMethod(textToCopy);
    this.showCopiedFeedback();
  }

  copyWithLegacyMethod(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  showCopiedFeedback() {
    this.buttonTarget.textContent = "Copied!";
    setTimeout(() => {
      this.buttonTarget.textContent = "Copy Link";
    }, 2000);
  }
}